module.exports = __webpack_public_path__ + "img/Iceland.43f4a188.svg";